module.exports = __webpack_public_path__ + "static/media/generic_facebook_new.4ce1fb31.jpg";